import React, { memo } from "react";
import { Avatar } from "@mui/material";
import { CheckCircleOutline, CloseRounded } from "@mui/icons-material";
import { CardContainer } from "../../OrderRequestDetail.style";
import { ORDER_ITEM_STATUS } from "../../constant";
import Box from "component/layoutComponents/Box/Box";
import { useTheme } from "styled-components";
import { Theme } from "../../types";
import Typography from "component/MarketPlace/Typography/Typography";
import { getAvatarName } from "utils/functions";
import { OrderDetails } from "../../types";

type Props = {
  requesterApprover?: string;
  isApprovalPage?: boolean;
  orderDetails?: OrderDetails;
  locale?: any;
};

const ApprovalDetailsCard = ({requesterApprover, isApprovalPage, orderDetails, locale }: Props) => {
  const theme = useTheme() as Theme;
  const orderStatus= orderDetails?.approval?.approval_status;
  const isDelegated = orderDetails?.approval?.assigned_approver !== orderDetails?.approval?.approved_by ? true : false;

  const assignedApproverName = orderDetails?.approval?.approver_name;
  const approvedByName = orderDetails?.approval?.approved_by_name;
  const approvedBy = orderDetails?.approval?.approved_by;
  return (
    <CardContainer>
      <Box padding="12px 16px">
        <Typography variant="h6" mb={1}>
          {locale?.approvalDetails}
        </Typography>
        {(orderStatus && orderStatus !== ORDER_ITEM_STATUS.PENDING) && (
          <Box paddingTop="8px">
            <Typography variant="overline">
              {locale?.status?.toUpperCase()}
            </Typography>          
            <Box display="flex" alignItems="center" paddingTop="8px">            
              {orderStatus === ORDER_ITEM_STATUS.APPROVED && (
                <>
                  <CheckCircleOutline htmlColor={theme.uptimeColors.generalColors.state.success.dark} fontSize="small" />
                  <Typography variant="body1" ml="12px" id="lbl-orderdetails-status">
                    {locale?.approved}
                  </Typography>
                </>
              )}
              {orderStatus === ORDER_ITEM_STATUS.NOT_APPROVED && (
                <>
                  <CloseRounded htmlColor={theme.uptimeColors.generalColors.state.danger.dark} fontSize="small" />
                  <Typography variant="body1" id="lbl-orderdetails-status"> 
                    {locale?.declined}
                  </Typography>
                </>
              )}
            </Box>
          </Box>
        )}
        <Box paddingTop="8px">
          {isApprovalPage ? (
            <>
            <Typography variant="overline">{locale?.requester?.toUpperCase()}</Typography>
            <Box display="flex" alignItems="center" paddingTop="8px">
              <Avatar>{getAvatarName(requesterApprover)}</Avatar>
              <Typography variant="body1" ml="16px" id="lbl-orderdetails-requester">
                {requesterApprover}
              </Typography>
            </Box>
            { approvedBy !== null && (
              <>
                <Typography variant="overline">{locale?.approver?.toUpperCase()}</Typography>
                <Box display="flex" alignItems="center" paddingTop="8px">
                  <Avatar>{getAvatarName(approvedByName)}</Avatar>
                  <Typography variant="body1" ml="16px" id="lbl-orderdetails-assigned_approver">
                    {approvedByName}
                  </Typography>
                </Box>
              </>
            )}
            {isDelegated && (
              <>
                <Typography variant="overline">{locale?.assignedApprover?.toUpperCase()}</Typography>
                <Box display="flex" alignItems="center" paddingTop="8px">
                  <Avatar>{getAvatarName(assignedApproverName)}</Avatar>
                  <Typography variant="body1" ml="16px" id="lbl-orderdetails-approved_by">
                    {assignedApproverName}
                  </Typography>
                </Box>              
              </>
            )}
            </>
          ):(
            <>
              {approvedBy !== null && (
                <>
                  <Typography variant="overline">{locale?.approver?.toUpperCase()}</Typography>
                  <Box display="flex" alignItems="center" paddingTop="8px">
                    <Avatar>{getAvatarName(approvedByName)}</Avatar>
                    <Typography variant="body1" ml="16px" id="lbl-orderdetails-approver">
                      {approvedByName}
                    </Typography>
                  </Box>
                </>
              )}
              {isDelegated && (
                <>
                  <Typography variant="overline">{locale?.assignedApprover?.toUpperCase()}</Typography>
                  <Box display="flex" alignItems="center" paddingTop="8px">
                    <Avatar>{getAvatarName(assignedApproverName)}</Avatar>
                    <Typography variant="body1" ml="16px" id="lbl-orderdetails-assigned_approver">
                      {assignedApproverName}
                    </Typography>
                  </Box>
                </>
              )}           
            </>
          )}       
        </Box>
      </Box>
    </CardContainer>
  );
};

export default memo(ApprovalDetailsCard);
